export const MapModelData = function () {
  return {
    mapAbbrivationResult: {},
    metaDataObject: {
      entitySeal: '',
      entityName: '',
      entityAbbreviation: '',
      jurisdictionUrl: '',
      jurisdictionProfile: '',
      timeStamp: '',
      adoptionLevel: '',
      adoptionDescription: ''
    }
  }
}
